const papersDataCambridgeAlevel = {
  mathematics: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2023-May-June/9709_s23_ms_61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2020-May-June/9709_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_qp_62.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2019-May-June/9709_s19_ms_61.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_33.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_42.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_52.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2023-May-June/9700_s23_ms_51.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2022-May-June/9700_s22_ms_51.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_51.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_51.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2019-May-June/9700_s19_ms_51.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_33.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_42.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_52.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2023-May-June/9701_s23_ms_51.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_51.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_51.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2020-May-June/9701_s20_ms_51.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2019-May-June/9701_s19_ms_51.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_51.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2023-May-June/9702_s23_ms_51.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2022-May-June/9702_s22_ms_51.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_51.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_51.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2019-May-June/9702_s19_ms_51.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_ms_32.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_ms_42.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2023-May-June/9708_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2023-May-June/9708_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2023-May-June/9708_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2023-May-June/9708_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2023-May-June/9708_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2023-May-June/9708_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2023-May-June/9708_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2023-May-June/9708_s23_ms_41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_ms_41.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_ms_41.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_ms_41.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2019-May-June/9708_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2019-May-June/9708_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2019-May-June/9708_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2019-May-June/9708_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2019-May-June/9708_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2019-May-June/9708_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2019-May-June/9708_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2019-May-June/9708_s19_ms_41.pdf',
        },
      ],
    },
  ],
};

export default papersDataCambridgeAlevel;
